import { OPACITY_13 } from 'constants/opacity';
import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';
import { styled } from '@mui/system';
import MuiSnackbar from '@mui/material/Snackbar';

export const OrderConfirmedCartDesktopSnackbar = styled(
  MuiSnackbar,
  {}
)(({ theme }) => ({
  '&.MuiSnackbar-root': {
    maxWidth: '100%',
    position: 'fixed',
    zIndex: 1,
    '& .MuiPaper-elevation6': {
      boxShadow: `${`inset 0px 1px 0px ${calculateRgbaWithAlpha(
        theme.palette.sectionNav.link.main,
        OPACITY_13
      )}`}`
    },
    bottom: '0rem'
  },
  '& .MuiSnackbarContent-root': {
    position: 'fixed',
    padding: '8px 0',
    width: '25rem',
    right: '0',
    backgroundColor: '#8B535E',
    borderRadius: '0rem',
    boxShadow: 'none',
    alignContent: 'flex-start',
    height: '6rem',
    bottom: '0rem'
  },
  '& .MuiSnackbarContent-message': {
    padding: '8px 20px',
    width: '100%'
  }
}));

export const OrderConfirmedCartMobileSnackbar = styled(
  MuiSnackbar,
  {}
)(({ theme }) => ({
  '&.MuiSnackbar-root': {
    maxWidth: '100%',
    position: 'fixed',
    bottom: '0rem',
    zIndex: 1,
    left: '0',
    right: '0',
    '& .MuiPaper-elevation6': {
      boxShadow: `${`inset 0px 1px 0px ${calculateRgbaWithAlpha(
        theme.palette.sectionNav.link.main,
        OPACITY_13
      )}`}`
    },
    width: '100%',
    height: '6rem'
  },
  '& .MuiSnackbarContent-root': {
    position: 'fixed',
    padding: '8px 20px',
    width: '100%',
    backgroundColor: '#8B535E',
    borderRadius: '0rem',
    boxShadow: 'none'
  },
  '& .MuiSnackbarContent-message': {
    padding: '8px 0',
    width: '100%'
  }
}));

export const Header = styled('span')({
  fontSize: '16px',
  fontWeight: '500'
});

export const Body = styled('span')({
  fontSize: '14px',
  fontWeight: '450'
});

export const OrderConfirmedMenuDesktopSnackbar = styled(
  MuiSnackbar,
  {}
)(({ theme }) => ({
  '&.MuiSnackbar-root': {
    width: '100%',
    position: 'relative',
    zIndex: 1,
    left: 'auto',
    bottom: '0',
    '& .MuiPaper-elevation6': {
      boxShadow: `${`inset 0px 1px 0px ${calculateRgbaWithAlpha(
        theme.palette.sectionNav.link.main,
        OPACITY_13
      )}`}`
    }
  },
  '& .MuiSnackbarContent-root': {
    position: 'relative',
    padding: '8px 0',
    width: '100%',
    right: '0',
    backgroundColor: '#8B535E',
    borderRadius: '0rem',
    boxShadow: 'none',
    alignContent: 'flex-start',
    height: '6rem',
    bottom: '0rem'
  },
  '& .MuiSnackbarContent-message': {
    padding: '8px 20px',
    width: '100%'
  }
}));

export const OrderConfirmedMenuMobileSnackbar = styled(
  MuiSnackbar,
  {}
)(({ theme }) => ({
  '&.MuiSnackbar-root': {
    width: '100%',
    position: 'fixed',
    zIndex: 1,
    left: 'auto',
    bottom: '0',
    '& .MuiPaper-elevation6': {
      boxShadow: `${`inset 0px 1px 0px ${calculateRgbaWithAlpha(
        theme.palette.sectionNav.link.main,
        OPACITY_13
      )}`}`
    }
  },
  '& .MuiSnackbarContent-root': {
    position: 'relative',
    padding: '8px 0',
    width: '100%',
    right: '0',
    backgroundColor: '#8B535E',
    borderRadius: '0rem',
    boxShadow: 'none',
    alignContent: 'flex-start',
    height: '6rem',
    bottom: '0rem'
  },
  '& .MuiSnackbarContent-message': {
    padding: '8px 20px',
    width: '100%'
  }
}));
